/** Modèle par défaut (site actuel) si une section Strapi est vide. */

export const DEFAULT_SUBTITLE =
  "est la branche d'accompagnement individuel du projet Tsahal Connection.";

export const DEFAULT_FEATURE_COLUMNS = [
  {
    title: 'Nous nous adaptons à vous.',
    body: "Notre équipe dévouée propose un soutien adapté à vos besoins, faisant preuve d'humanité et d'honnêteté.",
  },
  {
    title: 'Plus que des informations.',
    body: "Notre connaissance de l'administration et de la mentalité de l'armée israélienne permet de faciliter votre intégration dans les rangs de Tsahal.",
  },
  {
    title: 'Vous accompagner, notre fierté.',
    body: 'Nos objectifs principaux sont votre réussite et votre épanouissement dans les rangs de Tsahal ainsi que dans la société israélienne.',
  },
];

export const DEFAULT_SECTION_FORFAITS_BEFORE = 'Les forfaits';
export const DEFAULT_SECTION_FORFAITS_HIGHLIGHT = 'Expert Connection';

export const DEFAULT_FORFAITS = [
  {
    tabLabel: 'Forfait Classique',
    cardTitle: 'Classique',
    cardTagline: 'Mahal/Olim Bodedim (sans parents)',
    priceAmount: '1000',
    priceSuffix: 'TTC',
    installment: "<p>jusqu'à <strong>4X 250₪</strong> sans frais</p>",
    featureLines: [
      '1 entretien individuel',
      "1 rdv zoom d'orientation sur le processus de Mahal - Si candidat à Mahal",
      '4 journées de préparation (dont 1 journée spécialisée unités combattantes & commando)',
      '1 rdv zoom de préparation Tsav Rishon & Mahal - Si candidat à Mahal (1h30 à 2h)',
      'Aide administrative',
      "Mentoring jusqu'à l'incorporation",
      "Cadeaux avant l'entrée à l'armée (sous réserve de participation à 3 journées sur 4)",
    ],
    contractPath: '/contrat-suivi-classique',
    buttonLabel: "S'inscire",
  },
  {
    tabLabel: 'Forfait Expert',
    cardTitle: 'Expert',
    cardTagline: 'Olim avec parents',
    priceAmount: '2000',
    priceSuffix: 'TTC',
    installment: "<p>jusqu'à <strong>8X 250₪</strong> sans frais</p>",
    featureLines: [
      'Préparations aux tests militaires',
      '7 rendez-vous personnalisés adaptable selon les besoins (orientation, Tsav Rishon, Yom Hamea, cheelon aadafot, mehinot / études etc.)',
      'Aide administrative',
      'Accompagnement parents inclus',
      "Mentoring jusqu'à l'incorporation",
    ],
    contractPath: '/contrat-suivi-expert',
    buttonLabel: "S'inscire",
  },
];

export const DEFAULT_SECTION_SERVICES_BEFORE = 'Les services';
export const DEFAULT_SECTION_SERVICES_HIGHLIGHT = 'Expert Connection';

export const DEFAULT_SERVICE_CARDS = [
  {
    titleLine1: 'Entretien',
    titleLine2: 'individuel',
    priceAmount: '450',
    priceSuffix: 'TTC',
    installment: "<p>jusqu'à <strong>2X 225</strong> sans frais</p>",
    featureLines: [
      '1 entretien individuel (jusqu’à 45 minutes)',
      'Orientation personnalisée (postes, parcours, mehinot, études, cheelon aadafot)',
      'Échange ciblé et sans engagement (hors Tsav Rishon & Yom Hamea)',
    ],
    contractPath: '/contrat-entretien-individuel',
    buttonLabel: "S'inscire",
  },
  {
    titleLine1: 'Simulation',
    titleLine2: 'Tsav Richon/Yom Hamea',
    priceAmount: '550',
    priceSuffix: 'TTC',
    installment: "<p>jusqu'à <strong>2X 275</strong> sans frais</p>",
    featureLines: [
      '1 rendez-vous de préparation (1h30 à 2h)',
      'Préparation complète Tsav Rishon OU Yom Hamea',
      'Explication des épreuves & attentes de Tsahal',
      'Conseils pratiques et méthodologiques',
    ],
    contractPath: '/contrat-simulation-tsav-richon',
    buttonLabel: "S'inscire",
  },
];

export const DEFAULT_CTA_TITLE = 'Dites nous ce que vous voulez';
export const DEFAULT_CTA_BODY =
  "Vous souhaitez quelque chose qui n'apparaît pas dans la liste ? Contactez-nous afin de mettre en place un suivi ou service sur mesure.";

export const DEFAULT_SECTION_TESTIMONIALS_BEFORE = 'Ils en parlent';
export const DEFAULT_SECTION_TESTIMONIALS_HIGHLIGHT = 'mieux que nous';

export const DEFAULT_TESTIMONIALS = [
  {
    quote:
      "L'équipe est patiente, bienveillante et souriante tout en restant droite et honnête avec la réalité du service militaire, leur expérience du monde pré-armée est inégalable.",
    attribution: 'Ethan F. - Forfait Expert',
  },
  {
    quote:
      "Expert Connection arrive à jongler entre une connaissance parfaite du monde militaire et une écoute des futurs soldats. Cela m'a permis de trouver des objectifs à l'armée et de tout faire pour y arriver.",
    attribution: 'Eden S. - Suivi Avancé',
  },
  {
    quote:
      "Grâce à Expert Connection, j'ai pu rentrer à Mahal alors que c'était loin d'être gagné. Surtout, ils m'ont rassuré et préparer à toutes les étapes jusqu'à l'entrée à l'armée.",
    attribution: 'Simon B. - Forfait Mahal',
  },
];
